module.exports = __webpack_public_path__ + "img/9788954430760.23badf53.jpg";